// Hardcoded fallback used if /locales endpoint hasn't responded yet. The hook
// useEmailTemplateLocales fetches the source-of-truth list from the backend.
export const DEFAULT_SUPPORTED_LOCALES = ['es', 'en'];
